"use client";

export const PLAYBACK_SPEEDS = [0.5, 0.75, 1.0, 1.25, 1.5, 1.75, 2.0];

/**
 * Small speed picker for <audio>/<video>. Keeps UI minimal and reusable.
 *
 * Props:
 * - value: number
 * - onChange: (next: number) => void
 * - showLabel?: boolean (default true)
 * - label?: string (default "Speed")
 * - disabled?: boolean
 * - style?: React.CSSProperties (wrapper)
 * - selectStyle?: React.CSSProperties (select)
 */
export default function PlaybackSpeedSelect({
  value,
  onChange,
  showLabel = true,
  label = "Speed",
  disabled = false,
  style,
  selectStyle,
}) {
  const formatSpeed = (s) => (Number.isInteger(s) ? s.toFixed(1) : String(s));

  return (
    <label
      style={{
        display: "inline-flex",
        alignItems: "center",
        // gap: "6px",
        color: "#d0d8df",
        fontSize: "12px",
        ...style,
      }}
    >
      {showLabel && <span>{label}</span>}
      <select
        value={String(value)}
        disabled={disabled}
        onChange={(e) => onChange?.(Number(e.target.value))}
        style={{
          background: "rgba(0,0,0,0.35)",
          color: "#e6ecf1",
          border: "1px solid rgba(255,255,255,0.12)",
          borderRadius: "8px",
          padding: "4px",
          fontSize: "12px",
          outline: "none",
          cursor: disabled ? "not-allowed" : "pointer",
          ...selectStyle,
        }}
      >
        {PLAYBACK_SPEEDS.map((s) => (
          <option key={s} value={String(s)}>
            {formatSpeed(s)}
          </option>
        ))}
      </select>
    </label>
  );
}
